<template>
  <div>
    <b-container>
      <h1 class="text-left mt-2 mb-3">Impresszum</h1>
      <div class="bordered-container mt-4">
        <b-row cols="1" class="text-left mb-5">
          <b-col>
            <!-- A VALI – a személyre szabott vállalkozói információs portál célja a vállalkozások számára gyors, hiteles és
            személyre szabott információk biztosítása a vállalkozásokat leginkább érdeklő témakörökben.
            <br />
            <br /> -->
            A portál a
            <strong>
              GINOP PLUSZ-1.1.1-22-2022-00001, Célzott vállalkozásfejlesztési szolgáltatások biztosítása mikro-, kis- és
              középvállalkozások számára című kiemelt projekt keretében működik.
            </strong>
            A projekt célja a magyar mikro-, kis- és középvállalkozások versenyképességének erősítése, fejlődési
            lehetőségeik bővítése, különös tekintettel a hátrányos helyzetű térségekben és szabad vállalkozási zónákban
            működő vállalkozásokra.
            <br />
            <br />
            A program célzott vállalkozásfejlesztési szolgáltatásokkal támogatja az érintett vállalkozások fejlődését,
            hozzájárulva gazdasági teljesítményük, árbevételük, foglalkoztatási képességük és hozzáadott értékük
            növeléséhez.
            <br />
            <br />
            <strong>A honlap üzemeltetője:</strong> <br />Magyar Gazdaságfejlesztési Ügynökség Közhasznú Nonprofit
            Korlátolt Felelősségű Társaság<br /><br />
            <strong>Cégjegyzékszám:</strong> <br />Cg. 01-09-980439 <br /><br />
            <strong>Cím:</strong> <br />1074 Budapest, Rákóczi út 70-72 <br /><br />
            <strong>E-mail: </strong><br />
            <a href="mailto:info@mgfu.hu" class="link">info@mgfu.hu</a>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Impressum'
}
</script>

<style scoped>
.link {
  color: black !important;
}
</style>
